import { defineComponent as _defineComponent } from 'vue'
import { withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { h, useSlots, reactive } from "vue";
      import { assignSlotNodes, Slots } from "@lit-labs/vue-utils/wrapper-utils.js";
      import '@oicl/openbridge-webcomponents/dist/components/advice-menu-item/advice-menu-item.js';
      import {ObcMessageMenuItemSize} from '@oicl/openbridge-webcomponents/dist/components/message-menu-item/message-menu-item.js';

      export interface Props {
     hasIcon?: boolean;
     title?: string;
     description?: string;
     day?: string;
     time?: string;
     open?: boolean;
     size?: ObcMessageMenuItemSize;
     primaryActionLabel?: string;
     secondaryActionLabel?: string
   }

      
  
      export type {ObcMessageMenuItemSize} from '@oicl/openbridge-webcomponents/dist/components/message-menu-item/message-menu-item.js';
    
export default /*@__PURE__*/_defineComponent({
  __name: 'ObcAdviceMenuItem',
  props: {
    hasIcon: { type: Boolean },
    title: {},
    description: {},
    day: {},
    time: {},
    open: { type: Boolean },
    size: {},
    primaryActionLabel: {},
    secondaryActionLabel: {}
  },
  emits: ["primary-action-click", "secondary-action-click", "item-click"],
  setup(__props: any, { emit: __emit }) {

      const vueProps = __props;

  const defaults = reactive({} as Props);
  const vDefaults = {
    created(el: any) {
      for (const p in vueProps) {
        defaults[p as keyof Props] = el[p];
      }
    }
  };

  let hasRendered = false;

      const emit = __emit;

      const slots = useSlots() as Slots;

      const render = () => {
        const eventProps = {
    onPrimaryActionClick: (event: CustomEvent<void>) => emit('primary-action-click', event as CustomEvent<void>),
onSecondaryActionClick: (event: CustomEvent<void>) => emit('secondary-action-click', event as CustomEvent<void>),
onItemClick: (event: CustomEvent<{open: boolean}>) => emit('item-click', event as CustomEvent<{open: boolean}>)
  };
        const props = eventProps as (typeof eventProps & Props);

        
      for (const p in vueProps) {
        const v = vueProps[p as keyof Props];
        if ((v !== undefined) || hasRendered) {
          (props[p as keyof Props] as unknown) = v ?? defaults[p as keyof Props];
        }
      }

      hasRendered = true;
    

        return h(
          'obc-advice-menu-item',
          props,
          assignSlotNodes(slots)
        );
      };
    
return (_ctx: any,_cache: any) => {
  return _withDirectives((_openBlock(), _createBlock(render, null, null, 512)), [
    [vDefaults]
  ])
}
}

})